export function isNumber(value: unknown): value is number {
  return typeof value === "number" && isFinite(value);
}

export function isString(value: unknown): value is string {
  return typeof value === "string" || value instanceof String;
}

export function isNil(value: unknown): value is null | undefined {
  return value === null || value === undefined;
}

export function isNotNil<T>(x: T | null | undefined): x is T {
  return x === null || x === undefined;
}

// eslint-disable-next-line
export function isFunction(value: unknown): value is Function {
  return typeof value === "function";
}

export function isObject(value: unknown): value is object {
  return typeof value === "object" && value !== null;
}
